import React from "react";
import Weather from "./Weather"
import './App.css';



export default function App() {   
  return (
    <div className='container'>
      <Weather city = "London"/>
  
<footer className="text-center">
  This project was coded by Sarah Ward and is open sourced on <a href="https://github.com/Sarahwcode/weather-react" > Github</a>
  </footer>
  </div>
  );
}